/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { DataTable } from '@scuf/datatable';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
import React, { useContext, useEffect, useState } from 'react';
import {
  IAny,
  IDataTableColumn,
  IDetailComponentProps,
  TrainingData,
  meterDetailsFromParent
} from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import {
  EnergyUsagesDetailExpandMeterField,
  ListOfMeterDetails,
  UtilityMeterField
} from '../../../shared/Utils/Constants';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import {
  getConvertedValue,
  getMaxConvertedValueFromArray
} from '../../../shared/Utils/unitHandling/unitHandling';
import { ConversionType } from '../../../shared/Utils/unitHandling/UnitModel';
import { ApiContext } from '../../../../context/ApiContext';
import { Icon, Loader, Tooltip } from '@scuf/common';
import ElectricityIcon from '../../../../images/electricIconMeters.svg';
import './EmaasBaselineFormModalCommon.scss';
import _ from 'lodash';
import moment from 'moment';
import ConnectionError from '../../../shared/ErrorComponents/ConnectionError';

export const renderTableMeterColumns = (
  columnDetails: IDataTableColumn[],
  renderColumn: (cellData: ICellData) => JSX.Element
) => {
  return columnDetails.map((column: IDataTableColumn) => {
    return (
      <DataTable.Column
        key={column.field}
        className={column.className}
        field={column.field}
        header={column.header as any}
        sortable={column.sortable}
        renderer={renderColumn}
        initialWidth={column.initialWidth}
      />
    );
  });
};
interface displayColumnMeterDetails {
  ActivePowerDisplay?: boolean;
  PowerDemandDisplay?: boolean;
}
const EmaasEUAllUtilityMeterDetails = (props: IDetailComponentProps) => {
  const { getAllMeterData, bearerToken, requestContext } = props;
  const {
    onClickViewDetailsMeterTrend,
    enableViewDetailsMeterTrend,
    getMeterKpiFlag,
    refreshMeterKpi,
    userPreferedUnit,
    MAX_METERS_COUNT,
    getCurrentPage,
    submeterKpiSelectedPeriodCons
  } = useContext(ApiContext);

  const [getMeterData, setMeterData] = useState([] as meterDetailsFromParent[]);
  const [fieldSortOrder, setFieldSortOrder] = useState<number>(-1);
  const [sortFieldName, setSortFieldName] = useState<string>(
    ListOfMeterDetails.Meters
  );
  const [displayColumn, setDisplayColumn] = useState<displayColumnMeterDetails>(
    {} as displayColumnMeterDetails
  );

  let fromUnit: string;
  // if (true) {
  //   fromUnit = userPreferedUnit as any;
  // } else {
  //   fromUnit = energyMeasurementUnit;
  // }

  fromUnit = userPreferedUnit as any;

  useEffect(() => {
    setMeterData(getAllMeterData as meterDetailsFromParent[]);
    setDisplayColumn({
      ...displayColumn,
      ActivePowerDisplay:
        getAllMeterData && getAllMeterData[0]?.ActivePowerDisplay,
      PowerDemandDisplay:
        getAllMeterData && getAllMeterData[0]?.PowerDemandDisplay
    });
  }, [getAllMeterData]);

  const [t] = useTranslation();
  const d = descriptors.DetailedView;
  const de = descriptors.energyManagement;
  let columnDetails: IDataTableColumn[] = [
    {
      className: 'datatable-column-meter',
      field: ListOfMeterDetails.Meters,
      header: t(d.Meters),
      sortable: true,
      initialWidth: '10%'
    },
    {
      className: 'datatable-column-ElectricityConsumption',
      field: ListOfMeterDetails.LoadType,
      header: (
        <div>
          {t(d.LoadType)}
          <Tooltip
            element={
              <Icon
                root="common"
                name="badge-info"
                exactSize="0.875rem"
                className="emaas-summary-card-header-info-icon"
              />
            }
            event="hover"
            header={t(d.LoadType)}
            content={`${t(d.LoadTypeContent)}`}
            position="right center"
            size="small"
          />
        </div>
      ),
      sortable: false,
      initialWidth: '9%'
    },
    ...(submeterKpiSelectedPeriodCons
      ? [
          {
            className: 'datatable-column-ElectricityConsumption',
            field: ListOfMeterDetails.EnergyConsSelectedPeriod,
            header: (
              <div>
                {t(d.EnergyConsSelectedPeriod)}
                <Tooltip
                  element={
                    <Icon
                      root="common"
                      name="badge-info"
                      exactSize="0.875rem"
                      className="emaas-summary-card-header-info-icon"
                    />
                  }
                  event="hover"
                  header={t(d.EnergyConsSelectedPeriod)}
                  content={`${t(d.EnergyConsSelectedPeriodContent)}`}
                  position="right center"
                  size="small"
                />
              </div>
            ),
            sortable: false,
            initialWidth: '9%'
          }
        ]
      : []),
    {
      className: 'datatable-column-ElectricityConsumption',
      field: ListOfMeterDetails.EnergyConsToday,
      header: (
        <div>
          {t(d.EnergyConsToday)}
          <Tooltip
            element={
              <Icon
                root="common"
                name="badge-info"
                exactSize="0.875rem"
                className="emaas-summary-card-header-info-icon"
              />
            }
            event="hover"
            header={t(d.EnergyConsToday)}
            content={`${t(d.EnergyConsTodayContent)}`}
            position="right center"
            size="small"
          />
        </div>
      ),
      sortable: false,
      initialWidth: '9%'
    },
    {
      className: 'datatable-column-ElectricityConsumption',
      field: ListOfMeterDetails.EnergyConsMonth,
      header: (
        <div>
          {t(d.EnergyConsMonth)}
          <Tooltip
            element={
              <Icon
                root="common"
                name="badge-info"
                exactSize="0.875rem"
                className="emaas-summary-card-header-info-icon"
              />
            }
            event="hover"
            header={t(d.EnergyConsMonth)}
            content={`${t(d.EnergyConsMonthContent)}`}
            position="right center"
            size="small"
          />
        </div>
      ),
      sortable: false,
      initialWidth: '9%'
    },
    {
      className: 'datatable-column-ElectricityConsumption',
      field: ListOfMeterDetails.ElectricityConsumption,
      header: (
        <div>
          {t(d.ElectricityConsumption)}
          <Tooltip
            element={
              <Icon
                root="common"
                name="badge-info"
                exactSize="0.875rem"
                className="emaas-summary-card-header-info-icon"
              />
            }
            event="hover"
            header={t(d.ElectricityConsumption)}
            content={`${t(d.TotalEnergyConsumptionContent)}`}
            position="right center"
            size="small"
          />
        </div>
      ),
      sortable: false,
      initialWidth: '9%'
    },
    // {
    //   className: 'datatable-column-FifteenMinuteElectricConsumption',
    //   field: ListOfMeterDetails.FifteenMinuteElectricConsumption,
    //   header: t(d.FifteenMinuteElectricConsumption),
    //   sortable: false,
    //   initialWidth: '9%'
    // },
    // {
    //   className: 'datatable-column-FifteenMinuteElectricConsumptionPrediction',
    //   field: ListOfMeterDetails.FifteenMinuteElectricConsumptionPrediction,
    //   header: t(d.FifteenMinuteElectricConsumptionPrediction),
    //   sortable: false,
    //   initialWidth: '9%'
    // },
    {
      className: 'datatable-column-GraphPopup',
      field: ListOfMeterDetails.eqdetails,
      header: '',
      sortable: false,
      initialWidth: '5%'
    }
  ];

  if (displayColumn?.PowerDemandDisplay && !displayColumn?.ActivePowerDisplay) {
    columnDetails.splice(1, 0, {
      className: 'datatable-column-PowerDemand',
      field: ListOfMeterDetails.PowerDemand,
      header: (
        <div>
          {t(d.PowerDemand)}
          <Tooltip
            element={
              <Icon
                root="common"
                name="badge-info"
                exactSize="0.875rem"
                className="emaas-summary-card-header-info-icon"
              />
            }
            event="hover"
            header={t(d.PowerDemand)}
            content={`${t(d.ActivePowerContent)}`}
            position="right center"
            size="small"
          />
        </div>
      ),
      sortable: false,
      initialWidth: '10%'
    });
  } else if (
    displayColumn?.ActivePowerDisplay &&
    !displayColumn?.PowerDemandDisplay
  ) {
    columnDetails.splice(
      1,
      0,
      {
        className: 'datatable-column-PowerDemand',
        field: ListOfMeterDetails.ActivePower,
        header: (
          <div>
            {t(d.ActivePower)}
            <Tooltip
              element={
                <Icon
                  root="common"
                  name="badge-info"
                  exactSize="0.875rem"
                  className="emaas-summary-card-header-info-icon"
                />
              }
              event="hover"
              header={t(d.ActivePower)}
              content={`${t(d.ActivePowerContent)}`}
              position="right center"
              size="small"
            />
          </div>
        ),
        sortable: false,
        initialWidth: '10%'
      },
      {
        className: 'datatable-column-PowerDemand',
        field: ListOfMeterDetails.AVGpower,
        header: (
          <div>
            {t(d.AVGpower)}
            <Tooltip
              element={
                <Icon
                  root="common"
                  name="badge-info"
                  exactSize="0.875rem"
                  className="emaas-summary-card-header-info-icon"
                />
              }
              event="hover"
              header={t(d.AVGpower)}
              content={`${t(d.ActivePowerContent)}`}
              position="right center"
              size="small"
            />
          </div>
        ),
        sortable: false,
        initialWidth: '10%'
      }
      // ,{
      //   className: 'datatable-column-PowerDemand',
      //   field: ListOfMeterDetails.PeakPower,
      //   header: (
      //     <div>
      //     {t(d.PeakPower)}
      //     <Tooltip
      //       element={
      //         <Icon
      //           root="common"
      //           name="badge-info"
      //           exactSize="0.875rem"
      //           className="emaas-summary-card-header-info-icon"
      //         />
      //       }
      //       event="hover"
      //       header={t(d.PeakPower)}
      //       content={`${t(d.PeakPowerContent)}`}
      //       position="right center"
      //       size="small"
      //     />
      //   </div>
      // ),
      //   sortable: false,
      //   initialWidth: '10%'
      // }
    );
  } else if (
    displayColumn?.PowerDemandDisplay &&
    displayColumn?.ActivePowerDisplay
  ) {
    columnDetails.splice(
      1,
      0,
      {
        className: 'datatable-column-PowerDemand',
        field: ListOfMeterDetails.PowerDemand,
        header: t(d.PowerDemand),
        sortable: false,
        initialWidth: '10%'
      },
      {
        className: 'datatable-column-PowerDemand',
        field: ListOfMeterDetails.ActivePower,
        header: (
          <div>
            {t(d.ActivePower)}
            <Tooltip
              element={
                <Icon
                  root="common"
                  name="badge-info"
                  exactSize="0.875rem"
                  className="emaas-summary-card-header-info-icon"
                />
              }
              event="hover"
              header={t(d.ActivePower)}
              content={`${t(d.ActivePowerContent)}`}
              position="right center"
              size="small"
            />
          </div>
        ),
        sortable: false,
        initialWidth: '10%'
      },
      {
        className: 'datatable-column-PowerDemand',
        field: ListOfMeterDetails.AVGpower,
        header: (
          <div>
            {t(d.AVGpower)}
            <Tooltip
              element={
                <Icon
                  root="common"
                  name="badge-info"
                  exactSize="0.875rem"
                  className="emaas-summary-card-header-info-icon"
                />
              }
              event="hover"
              header={t(d.AVGpower)}
              content={`${t(d.ActivePowerContent)}`}
              position="right center"
              size="small"
            />
          </div>
        ),
        sortable: false,
        initialWidth: '10%'
      }
    );
  }

  // useEffect(() => {
  //   console.log("enableViewDetailsMeterTrend",enableViewDetailsMeterTrend,onClickViewDetailsMeterTrend)
  //   if (
  //     enableViewDetailsMeterTrend &&
  //     onClickViewDetailsMeterTrend
  //   ) {
  //     console.log("enableViewDetailsMeterTrend true",enableViewDetailsMeterTrend,onClickViewDetailsMeterTrend)
  //     columnDetails.push({
  //       className: 'datatable-column-details',
  //       field: ListOfMeterDetails.eqdetails,
  //       header: '',
  //       sortable: false,
  //       initialWidth: '5%'
  //     });
  //   }
  // }, [enableViewDetailsMeterTrend,onClickViewDetailsMeterTrend]);

  const cellDataRenderer = (cellData: ICellData) => {
    // const tableFirstRow = getMeterHeader(props.isNILM);
    const { value, field, rowData } = cellData;

    // let maxVal = [
    //   rowData.PowerDemand, rowData.ActivePower
    //     ,rowData.ElectricityConsumption
    //     ,rowData.FifteenMinuteElectricConsumption
    //     : rowData.FifteenMinuteElectricConsumptionPrediction
    //     ? rowData.FifteenMinuteElectricConsumptionPrediction
    //     : null
    // ];

    switch (field) {
      case ListOfMeterDetails.Meters:
        return (
          <div className="kpimetersNameDiv">
            <img className="card-electricity-icon" src={ElectricityIcon} />
            <span>{rowData.meterName}</span>
          </div>
        );
        break;
      case ListOfMeterDetails.LoadType:
        return (
          <div className="kpimetersNameDiv">
            <span>
              {rowData && rowData.LoadType !== '' ? rowData.LoadType : '--'}
            </span>
          </div>
        );
        break;
      case ListOfMeterDetails.PowerDemand:
        let toUnitPowerDemand = getMaxConvertedValueFromArray(
          ConversionType?.ELECTRICITY,
          rowData.PowerDemandUnit !== ''
            ? rowData.PowerDemandUnit
            : 'kilowatt hour',
          [rowData.PowerDemand ? rowData.PowerDemand : null]
        ).Unit;
        return (
          <div className={rowData.PowerDemand === '' ? 'powerDemondCss' : ''}>
            {isNaN(Number(rowData.PowerDemand)) || rowData.PowerDemand === ''
              ? '--'
              : `${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.PowerDemandUnit !== ''
                      ? rowData.PowerDemandUnit
                      : 'kilowatt hour',
                    rowData.PowerDemand,
                    toUnitPowerDemand
                  ).Value
                } ${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.PowerDemandUnit !== ''
                      ? rowData.PowerDemandUnit
                      : 'kilowatt hour',
                    rowData.PowerDemand,
                    toUnitPowerDemand
                  ).Unit
                }`}
          </div>
        );
        break;
      case ListOfMeterDetails.ActivePower:
        let toUnitActivePower = getMaxConvertedValueFromArray(
          ConversionType?.ELECTRICITY,
          rowData.ActivePowerUnit !== ''
            ? rowData.ActivePowerUnit
            : 'kilowatt hour',
          [rowData.ActivePower ? rowData.ActivePower : null]
        ).Unit;
        return (
          <div className={rowData.ActivePower === '' ? 'powerDemondCss' : ''}>
            {isNaN(Number(rowData.ActivePower)) || rowData.ActivePower === ''
              ? '--'
              : `${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.ActivePowerUnit !== ''
                      ? rowData.ActivePowerUnit
                      : 'kilowatt hour',
                    rowData.ActivePower,
                    toUnitActivePower
                  ).Value
                } ${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.ActivePowerUnit !== ''
                      ? rowData.ActivePowerUnit
                      : 'kilowatt hour',
                    rowData.ActivePower,
                    toUnitActivePower
                  ).Unit
                }`}
          </div>
        );
        break;
      case ListOfMeterDetails.AVGpower:
        let toUnitAVGpower = getMaxConvertedValueFromArray(
          ConversionType?.ELECTRICITY,
          rowData.avgPowerOfActivePowerUnit !== ''
            ? rowData.avgPowerOfActivePowerUnit
            : 'kilowatt hour',
          [rowData.avgPowerOfActivePower ? rowData.avgPowerOfActivePower : null]
        ).Unit;
        return (
          <div
            className={
              rowData.avgPowerOfActivePower === '' ? 'powerDemondCss' : ''
            }
          >
            {rowData.avgPowerOfActivePower === ''
              ? '--'
              : `${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.avgPowerOfActivePowerUnit !== ''
                      ? rowData.avgPowerOfActivePowerUnit
                      : 'kilowatt hour',
                    rowData.avgPowerOfActivePower,
                    toUnitAVGpower
                  ).Value
                } ${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.avgPowerOfActivePowerUnit !== ''
                      ? rowData.avgPowerOfActivePowerUnit
                      : 'kilowatt hour',
                    rowData.avgPowerOfActivePower,
                    toUnitAVGpower
                  ).Unit
                }`}
          </div>
        );
        break;
      case ListOfMeterDetails.PeakPower:
        let toUnitPeakPower = getMaxConvertedValueFromArray(
          ConversionType?.ELECTRICITY,
          rowData.maxPowerOfActivePowerUnit !== ''
            ? rowData.maxPowerOfActivePowerUnit
            : 'kilowatt hour',
          [rowData.maxPowerOfActivePower ? rowData.maxPowerOfActivePower : null]
        ).Unit;
        return (
          <div
            className={
              rowData.maxPowerOfActivePower === '' ? 'powerDemondCss' : ''
            }
          >
            {rowData.maxPowerOfActivePower === '' ? (
              '--'
            ) : (
              <div>
                {`${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.maxPowerOfActivePowerUnit !== ''
                      ? rowData.maxPowerOfActivePowerUnit
                      : 'kilowatt hour',
                    rowData.maxPowerOfActivePower,
                    toUnitPeakPower
                  ).Value
                } ${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.maxPowerOfActivePowerUnit !== ''
                      ? rowData.maxPowerOfActivePowerUnit
                      : 'kilowatt hour',
                    rowData.maxPowerOfActivePower,
                    toUnitPeakPower
                  ).Unit
                }`}
                <Tooltip
                  className="meterKPIToolTipActivePower"
                  element={
                    <Icon
                      root="common"
                      name="badge-info"
                      exactSize="0.875rem"
                      className="emaas-summary-card-header-info-icon"
                    />
                  }
                  event="hover"
                  content={`Peak Time : ${
                    rowData.maxPowerTimeOfActivePower
                      ? moment(rowData.maxPowerTimeOfActivePower).format(
                          'MM/DD/YYYY hh:mm'
                        )
                      : ''
                  }`}
                  position="right center"
                  size="small"
                />
              </div>
            )}
          </div>
        );
        break;
      case ListOfMeterDetails.EnergyConsToday:
        let toUnitElectricityConsumptionToday = getMaxConvertedValueFromArray(
          ConversionType?.ELECTRICITY,
          fromUnit === 'kilowatt hour' ? rowData.EnergyConsTodayUnit : fromUnit,
          [rowData.EnergyConsToday ? rowData.EnergyConsToday : null],
          rowData.EnergyConsTodayUnit
          // 'kilowatt hour'
        ).Unit;
        return (
          <div
            className={rowData.EnergyConsToday === '' ? 'powerDemondCss' : ''}
          >
            {isNaN(Number(rowData.EnergyConsToday)) ||
            rowData.EnergyConsToday === ''
              ? '--'
              : `${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.EnergyConsTodayUnit !== ''
                      ? rowData.EnergyConsTodayUnit
                      : 'kilowatt hour',
                    rowData.EnergyConsToday,
                    toUnitElectricityConsumptionToday
                  ).Value
                } ${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.EnergyConsTodayUnit !== ''
                      ? rowData.EnergyConsTodayUnit
                      : 'kilowatt hour',
                    rowData.EnergyConsToday,
                    toUnitElectricityConsumptionToday
                  ).Unit
                }`}
          </div>
        );
        break;
      case ListOfMeterDetails.EnergyConsMonth:
        let toUnitElectricityConsumptionMonth = getMaxConvertedValueFromArray(
          ConversionType?.ELECTRICITY,
          fromUnit === 'kilowatt hour' ? rowData.EnergyConsMonthUnit : fromUnit,
          [rowData.EnergyConsMonth ? rowData.EnergyConsMonth : null],
          rowData.EnergyConsMonthUnit
          // 'kilowatt hour'
        ).Unit;
        return (
          <div
            className={rowData.EnergyConsMonth === '' ? 'powerDemondCss' : ''}
          >
            {isNaN(Number(rowData.EnergyConsMonth)) ||
            rowData.EnergyConsMonth === ''
              ? '--'
              : `${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.EnergyConsMonthUnit !== ''
                      ? rowData.EnergyConsMonthUnit
                      : 'kilowatt hour',
                    rowData.EnergyConsMonth,
                    toUnitElectricityConsumptionMonth
                  ).Value
                } ${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.EnergyConsMonthUnit !== ''
                      ? rowData.EnergyConsMonthUnit
                      : 'kilowatt hour',
                    rowData.EnergyConsMonth,
                    toUnitElectricityConsumptionMonth
                  ).Unit
                }`}
          </div>
        );
        break;
      case ListOfMeterDetails.EnergyConsSelectedPeriod:
        let toUnitElectricityConsumptionSelectedPeriod = getMaxConvertedValueFromArray(
          ConversionType?.ELECTRICITY,
          fromUnit === 'kilowatt hour'
            ? rowData.EnergyConsSelectedPeriodUnit
            : fromUnit,
          [
            rowData.EnergyConsSelectedPeriod
              ? rowData.EnergyConsSelectedPeriod
              : null
          ],
          rowData.EnergyConsSelectedPeriodUnit
          // 'kilowatt hour'
        ).Unit;
        return (
          <div
            className={
              rowData.EnergyConsSelectedPeriod === '' ? 'powerDemondCss' : ''
            }
          >
            {isNaN(Number(rowData.EnergyConsSelectedPeriod)) ||
            rowData.EnergyConsSelectedPeriod === ''
              ? '--'
              : `${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.EnergyConsSelectedPeriodUnit !== ''
                      ? rowData.EnergyConsSelectedPeriodUnit
                      : 'kilowatt hour',
                    rowData.EnergyConsSelectedPeriod,
                    toUnitElectricityConsumptionSelectedPeriod
                  ).Value
                } ${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.EnergyConsSelectedPeriodUnit !== ''
                      ? rowData.EnergyConsSelectedPeriodUnit
                      : 'kilowatt hour',
                    rowData.EnergyConsMonth,
                    toUnitElectricityConsumptionSelectedPeriod
                  ).Unit
                }`}
          </div>
        );
        break;
      case ListOfMeterDetails.ElectricityConsumption:
        let toUnitElectricityConsumption = getMaxConvertedValueFromArray(
          ConversionType?.ELECTRICITY,
          fromUnit === 'kilowatt hour'
            ? rowData.ElectricityConsumptionUnit
            : fromUnit,
          [
            rowData.ElectricityConsumption
              ? rowData.ElectricityConsumption
              : null
          ],
          rowData.ElectricityConsumptionUnit
          // 'kilowatt hour'
        ).Unit;

        return (
          <div
            className={
              rowData.ElectricityConsumption === '' ? 'powerDemondCss' : ''
            }
          >
            {isNaN(Number(rowData.ElectricityConsumption)) ||
            rowData.ElectricityConsumption === ''
              ? '--'
              : `${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.ElectricityConsumptionUnit !== ''
                      ? rowData.ElectricityConsumptionUnit
                      : 'kilowatt hour',
                    rowData.ElectricityConsumption,
                    toUnitElectricityConsumption
                  ).Value
                } ${
                  getConvertedValue(
                    ConversionType?.ELECTRICITY,
                    rowData.ElectricityConsumptionUnit !== ''
                      ? rowData.ElectricityConsumptionUnit
                      : 'kilowatt hour',
                    rowData.ElectricityConsumption,
                    toUnitElectricityConsumption
                  ).Unit
                }`}
          </div>
        );
        break;
      // case ListOfMeterDetails.FifteenMinuteElectricConsumption:
      //   return (
      //     <div
      //       className={
      //         rowData.FifteenMinuteElectricConsumption === ''
      //           ? 'powerDemondCss'
      //           : ''
      //       }
      //     >
      //       {rowData.FifteenMinuteElectricConsumption === ''
      //         ? '--'
      //         : `${getConvertedValue(
      //           ConversionType?.ELECTRICITY,
      //           rowData.FifteenMinuteElectricConsumptionUnit !== ''
      //             ? rowData.FifteenMinuteElectricConsumptionUnit
      //             : 'kilowatt hour',
      //           rowData.FifteenMinuteElectricConsumption
      //         ).Value
      //         } ${getConvertedValue(
      //           ConversionType?.ELECTRICITY,
      //           rowData.FifteenMinuteElectricConsumptionUnit !== ''
      //             ? rowData.FifteenMinuteElectricConsumptionUnit
      //             : 'kilowatt hour',
      //           rowData.FifteenMinuteElectricConsumption
      //         ).Unit
      //         }`}
      //     </div>
      //   );
      //   break;
      // case ListOfMeterDetails.FifteenMinuteElectricConsumptionPrediction:
      //   return (
      //     <div
      //       className={
      //         rowData.FifteenMinuteElectricConsumptionPrediction === ''
      //           ? 'powerDemondCss'
      //           : ''
      //       }
      //     >
      //       {rowData.FifteenMinuteElectricConsumptionPrediction === ''
      //         ? '--'
      //         : `${getConvertedValue(
      //           ConversionType?.ELECTRICITY,
      //           rowData.FifteenMinuteElectricConsumptionPredictionUnit !==
      //             ''
      //             ? rowData.FifteenMinuteElectricConsumptionPredictionUnit
      //             : 'kilowatt hour',
      //           rowData.FifteenMinuteElectricConsumptionPrediction
      //         ).Value
      //         } ${getConvertedValue(
      //           ConversionType?.ELECTRICITY,
      //           rowData.FifteenMinuteElectricConsumptionPredictionUnit !==
      //             ''
      //             ? rowData.FifteenMinuteElectricConsumptionPredictionUnit
      //             : 'kilowatt hour',
      //           rowData.FifteenMinuteElectricConsumptionPrediction
      //         ).Unit
      //         }`}
      //     </div>
      //   );
      //   break;
      case ListOfMeterDetails.eqdetails:
        return (
          <div
            className="trend-vis-icon-wrapper"
            onClick={(e) => {
              enableViewDetailsMeterTrend &&
                onClickViewDetailsMeterTrend &&
                onClickViewDetailsMeterTrend(
                  rowData.meterID,
                  rowData.meterName
                );
            }}
          >
            <Icon name="graph" root="global" />
          </div>
        );
      default:
        return <></>;
        break;
    }
  };

  const onRefresh = () => refreshMeterKpi(true);

  const handlePagination = (activePage: string | number) => {
    if (getCurrentPage) {
      getCurrentPage(activePage);
    }
  };

  return (
    <div className="meterDetails-div">
      {getMeterKpiFlag!.loading ? (
        <Loader className="optimization-chart-loader" />
      ) : getMeterKpiFlag!.error ? (
        <div className="errorDisplay">
          <ConnectionError
            title={t(de.CONNECTIONERRORTITLE)}
            message={t(de.CONNECTIONERROR)}
            onRefresh={onRefresh}
          />
        </div>
      ) : (
        <>
          <span className="meterSubHeader">{t(de.meterSubHeaders)}</span>
          <DataTable
            className="meterDetails-DataTable meterKPI"
            data={getMeterData}
            // reorderableColumns={true}
            // resizableColumns={true}
            onSort={({ sortField, sortOrder }) => {
              setFieldSortOrder(sortOrder as number);
              setSortFieldName(sortField);
            }}
            sortField={sortFieldName}
            sortOrder={fieldSortOrder}
          >
            {renderTableMeterColumns(columnDetails, cellDataRenderer)}
            <DataTable.Pagination
              totalItems={getMeterData.length}
              itemsPerPage={MAX_METERS_COUNT!}
              onPageChange={(activePage) => handlePagination(activePage)}
            />
          </DataTable>
        </>
      )}
    </div>
  );
};

export default EmaasEUAllUtilityMeterDetails;
